export default __webpack_public_path__ + "static/media/AC_8.4cb90a23.jpg";